import { render, staticRenderFns } from "./PageBanner.vue?vue&type=template&id=03cac8d3&scoped=true&"
import script from "./PageBanner.vue?vue&type=script&lang=js&"
export * from "./PageBanner.vue?vue&type=script&lang=js&"
import style0 from "./PageBanner.vue?vue&type=style&index=0&id=03cac8d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cac8d3",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageBanner.vue
// module id = 87
// module chunks = 0